export enum ProcessStep {
    SAMPLE_RECEPTION ="SAMPLE_RECEPTION",
    MERGING ="MERGING",
    REACTION_MIX ="REACTION_MIX",
    THERMAL_CYCLER="THERMAL_CYCLER",
    DT_REMOVAL="DT_REMOVAL",
    SPLITTING="SPLITTING",
    SEQUENCING="SEQUENCING",
    PREPARING="PREPARING",
    REDO="REDO",
    REACTIONS_PLACEMENT="REACTIONS_PLACEMENT",
    EXTRACTION="EXTRACTION",
    ENTRY_QC="ENTRY_QC",
    ENTRY_QC_OK="ENTRY_QC_OK",
    LIB_PREP_START="LIB_PREP_START",
    ENRICHMENT="ENRICHMENT",
    FRAGMENTATION="FRAGMENTATION",
    CDNA_SYNTHESIS="CDNA_SYNTHESIS",
    END_REPAIR="END_REPAIR",
    AMPLIFICATION="AMPLIFICATION",
    LIB_QC="LIB_QC",
    LIB_PREP_COMPLETE="LIB_PREP_COMPLETE"
    }
